import React from 'react';
import { Classable, HasChildren } from '@shapeable/types';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { WARM_GREY, PageContextDefinition, LayoutShell, SiteFooterLayout, UiConfig, UiProvider } from '@shapeable/ui';
import * as pageLayouts from './page-layouts';
import * as sliceLayouts from './slice-layouts';
import { LANG_STRINGS } from '../lang';
import { LayoutStyles, themeOverrides, YELLOW, YELLOW_DARK } from '../theme';

export type LayoutPropTypes = Classable & HasChildren & {
  path?: string;
  data?: any;
  pageContext?: PageContextDefinition;
};

const LayoutDefaultProps: LayoutPropTypes = {
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    ${LayoutStyles};
  `,
});

const FooterStyles = breakpoints({
  base: css`
  `,
});

const BodyStyles = breakpoints({
  base: css`
    flex-grow: 1;
  `,
});

// -------- Components -------->

const My = {
  Container: styled(LayoutShell)`${ContainerStyles}`,
  Body: styled.div`${BodyStyles}`,
  Footer: styled(SiteFooterLayout)`${FooterStyles}`,
};

export const Layout: React.FC<LayoutPropTypes> = (props) => {
  const { className, children } = props;

  const config: UiConfig = {
    layouts: { pageLayouts, sliceLayouts, defaultPageLayout: pageLayouts.PageLayoutDefault },
    langStrings: LANG_STRINGS,
    menuBar: {

    },
    theme: themeOverrides,
    header: {
      variant: 'overlay',
      // showThemeMode: true,
    },
    componentProps: {
      SiteMenuBar: {
        colors: {
          background: 'dark',
        }
      },
      PageHeader: {
        themeMode: 'dark',
      },
      NavigationMenuItem: {
        colors: {
          hover: {
            text: 'light',
            background: YELLOW_DARK,
          },
        }
      },
      MenuItemLink: {
        colors: {
          hover: {
            text: YELLOW_DARK,
            fill: YELLOW_DARK,
            border: YELLOW_DARK,
          },
          active: {
            text: YELLOW_DARK,
            fill: YELLOW_DARK,
            border: YELLOW_DARK,
          }
        }
      },
      MenuItem: {
        colors: {
          hover: {
            text: 'light',
            background: YELLOW_DARK,
          },
        }
      },
      SiteFooterLayout: {
        colors: {
          background: WARM_GREY,
          dark: {
            background: '#1E1E1E',
          }
        }
      }
    }
  }
  
  return (
    <UiProvider value={config}>
      <My.Container
        className={className}
        includeTooltip
        tooltipProps={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <My.Body>
          {children}
        </My.Body>
        <My.Footer />
      </My.Container>
    </UiProvider>
  );
  
  
};

Layout.defaultProps = LayoutDefaultProps;

